export type BeepOpts = {
  freq: number;
  durMs?: number;
  type?: OscillatorType;
  gain?: number;
  attackMs?: number;
  decayMs?: number;
};

export class SfxSynth {
  private ctx?: AudioContext;
  private master?: GainNode;

  ensure(): void {
    if (!this.ctx) {
      this.ctx = new (window.AudioContext ||
        (window as any).webkitAudioContext)();

      this.master = this.ctx.createGain();
      this.master.gain.value = 0.25; // a bit louder than default
      this.master.connect(this.ctx.destination);
    }

    if (this.ctx.state === "suspended") {
      // Must be called from a user gesture in many WebViews
      this.ctx.resume().catch(() => {});
    }
  }

  beep(opts: BeepOpts): void {
    if (!this.ctx || !this.master) return;

    const {
      freq,
      durMs = 60,
      type = "square",
      gain = 0.8,
      attackMs = 4,
      decayMs = 50,
    } = opts;

    const t0 = this.ctx.currentTime;
    const osc = this.ctx.createOscillator();
    const g = this.ctx.createGain();

    osc.type = type;
    osc.frequency.setValueAtTime(freq, t0);

    // Simple envelope (avoid clicks)
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(gain, t0 + attackMs / 1000);
    g.gain.exponentialRampToValueAtTime(
      0.0001,
      t0 + (attackMs + decayMs) / 1000
    );

    osc.connect(g);
    g.connect(this.master);

    osc.start(t0);
    osc.stop(t0 + durMs / 1000);
  }

  arpeggio(
    freqs: number[],
    spacingMs = 40,
    type: OscillatorType = "square"
  ): void {
    freqs.forEach((f, i) => {
      setTimeout(
        () => this.beep({ freq: f, durMs: spacingMs + 20, type }),
        i * spacingMs
      );
    });
  }
}
